/*! collapse */
$(document).ready(function () {

    //== Collapse
    //
    // Requires wrapper of .collapse-container with 2 children:
    // .collapse-toggle (button) and
    // .collapse-content (collapse region)
    // Option: add .vanishing to toggle to make it vanish on first use

    // Init
    // For ideal progressive enhancement, add style="display:none" to the toggle element
    $('.collapse-container').each(function (index) {
        var id = '';
        if ($(this).attr('id')) {
            id += $(this).attr('id');
            id += '_';
        }
        id += 'collapse';
        id += index;
        $(this).find('.collapse-toggle').show().removeClass('active').attr('aria-expanded', 'false').attr('tabindex', '0').attr('role', 'button').attr('title', 'Expand').attr('aria-controls', id).click(function () { return false; });
        $(this).find('.collapse-content').hide().removeClass('active').attr('aria-hidden', 'true').attr('id', id);
    });


    // Core functionality: click toggle expands content block
    // Click event handler
    var collapse = '.collapse-container .collapse-toggle';
    $(collapse).click(function (e) {
        e.preventDefault();
        var $target = $(e.target);
        var isVisible = $target.hasClass('active');
        var isVanishing = $target.hasClass('vanishing');
        var $container = $target.closest('.collapse-container');
        var animLength = 0;
        // TODO: Assign id and aria-controls
        if (isVisible != true) {
            if (isVanishing) {
                $target.hide();
            }
            $target.addClass('active').attr('aria-expanded', 'true');
            $container.find('.collapse-content').addClass('active').attr('aria-hidden', 'false').slideDown(animLength);
            $container.find('.collapse-content :focusable')[0].focus();
        } else {
            $target.removeClass('active').attr('aria-expanded', 'false');
            $container.find('.collapse-content').removeClass('active').attr('aria-hidden', 'true').slideUp(animLength);
        }
        return false;
    });
});